import { render, staticRenderFns } from "./CaseCard.vue?vue&type=template&id=31efa8a8&scoped=true&"
import script from "./CaseCard.vue?vue&type=script&lang=js&"
export * from "./CaseCard.vue?vue&type=script&lang=js&"
import style0 from "./CaseCard.vue?vue&type=style&index=0&id=31efa8a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31efa8a8",
  null
  
)

export default component.exports